export default __webpack_public_path__ + "static/media/lluna-logo.495ef743.svg";